import ecomInterceptor from "@/interceptors/ecomInterceptor";
import { IFormData } from "@/Interfaces/interface.form";
import { extractErrorMessage } from "@/utils/ErrorHandlers";
import toast from "react-hot-toast";

export const submitEnquiry = async (
  values: IFormData,
  platform: string
): Promise<void> => {
  try {
    const sanitize = (value?: string) => {
      if (typeof value !== "string") return "";
      return value.trim().replace(/\s+/g, " ");
    };

    const data = {
      name: sanitize(values.name),
      email: sanitize(values.email),
      phoneNumber: sanitize(values.contactNumber),
      note: sanitize(values.message),
      type: sanitize(values.enquiryType),
      platform: sanitize(platform),
    };

    await ecomInterceptor.post(`/enquiry/contact-us`, data);
  } catch (error) {
    const message = extractErrorMessage(error);
    toast.error(message);
    console.error(message);
    throw error;
  }
};
